// extracted by mini-css-extract-plugin
export var cardContent = "ResourceCard-module--cardContent--ov5lx";
export var cardDescription = "ResourceCard-module--cardDescription--r633Q";
export var cardTitle = "ResourceCard-module--cardTitle--fcS6F";
export var categoryBadge = "ResourceCard-module--categoryBadge--3IsSD";
export var ctaButton = "ResourceCard-module--ctaButton--JVuH4";
export var imageWrapper = "ResourceCard-module--imageWrapper--clq-z";
export var resourceCard = "ResourceCard-module--resourceCard--vX916";